import React from 'react'
import { Link } from 'gatsby'

const services = [
  { icon: 'elder', label: 'Elder Care', to: '/elder-care/' },
  { icon: 'attendant', label: 'Trained Attendant', to: '/trained-attendants/' },
  { icon: 'physio', label: 'Physiotherapy', to: '/physiotherapy/' },
  { icon: 'critical', label: 'Critical Care', to: '/critical-care/' },
  { icon: 'equipment', label: 'Medical Equipment', to: '/medical-equipment/' },
  { icon: 'nursing', label: 'Nursing', to: '/nursing/' },
  { icon: 'doctor', label: 'Doctor Consultation', to: '/doctor-consultations/' },
  { icon: 'mother', label: 'Mother & Baby Care', to: '/new-born-baby-mother-care/' },
  { icon: 'lab', label: 'Lab Tests', to: '/diagnostic/' },
  // Speciality Pharma has no dedicated page; rendered without a link until one exists.
  { icon: 'pharma', label: 'Speciality Pharma', to: null },

]

function PorteaServices() {
  return <div className="box is-radiusless is-shadowless services-panel">
    <div className="header">Portea Services</div>
    {services.map(({ icon, label, to }) => {
      const inner = (
        <>
          <i className={`icn-service ${icon}`} />
          <p>{label}</p>
        </>
      )
      return to ? (
        <Link key={label} to={to} className="service-item">
          {inner}
        </Link>
      ) : (
        <div key={label} className="service-item">
          {inner}
        </div>
      )
    })}
  </div>
}

export default PorteaServices;
